// Imports
var ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ = require("../../../../../../node_modules/css-loader/dist/runtime/noSourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.GoalCards__flexibleContainer___aJQgB {
    display: flex;
    flex-wrap: wrap;
    justify-content: center;
    align-items: center;
}

.GoalCards__goalCard___pqGnf {
    max-height: 70px;
    max-width: 50px;
    display: inline-flex;
    flex-wrap: wrap;
    justify-content: center;
    margin: 5px;
}

.GoalCards__goalCardBody___HN0kR {
    max-height: 25px;
}

.GoalCards__goalCardFooter___McuxR {
    color: gray;
    position: relative;
    font-size: 9px;
    bottom: 4px;
}

.GoalCards__marginLeft1em___wMO5J {
    margin-left: 1em;
}

.GoalCards__marginRight1em___jnjw_ {
    margin-right: 1em;
}

.GoalCards__archivedGoal___u7oyp {
    font-style: italic;
}

.GoalCards__verbIcon___EyYdo {
    font-size: 11px;
    position: relative;
    bottom: 8px;
}

.GoalCards__goalDaysLeft___Po8M2 {
    position: relative;
    color: white;
    font-size: 12px;
    z-index: 1;
    border-radius: 2px;
    padding: 0px 3px;
    bottom: 17px;
}

.GoalCards__goalDaysLeft_Good___rLZAe {
    color: white;
    background: green;
    opacity: 0.7;
}

.GoalCards__goalDaysLeft_Bad___ovpgJ {
    color: white;
    background: red;
    font-weight: bold;
}

.GoalCards__goalDaysLeft_Untracked___GXCG1 {
    color: white;
    background: rgba(0,0,0,0.5);
    font-size: 12px;
    border-radius: 3px;
    font-weight: bold;
    opacity: 0.5;
}

.GoalCards__goalDifficulty___yMfv9 {
    position: relative;
    bottom: 8px;  
    font-style: italic;
}

.GoalCards__beeminderLink___NaqF1 {
    font-size: 10px;
}

.GoalCards__arrowIcon___gQAO4 {
    position: relative;
    right: 40px;
    font-size: 8px;
    bottom: 8px;
    font-weight: bold;
}
`, ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"flexibleContainer": `GoalCards__flexibleContainer___aJQgB`,
	"goalCard": `GoalCards__goalCard___pqGnf`,
	"goalCardBody": `GoalCards__goalCardBody___HN0kR`,
	"goalCardFooter": `GoalCards__goalCardFooter___McuxR`,
	"marginLeft1em": `GoalCards__marginLeft1em___wMO5J`,
	"marginRight1em": `GoalCards__marginRight1em___jnjw_`,
	"archivedGoal": `GoalCards__archivedGoal___u7oyp`,
	"verbIcon": `GoalCards__verbIcon___EyYdo`,
	"goalDaysLeft": `GoalCards__goalDaysLeft___Po8M2`,
	"goalDaysLeft_Good": `GoalCards__goalDaysLeft_Good___rLZAe`,
	"goalDaysLeft_Bad": `GoalCards__goalDaysLeft_Bad___ovpgJ`,
	"goalDaysLeft_Untracked": `GoalCards__goalDaysLeft_Untracked___GXCG1`,
	"goalDifficulty": `GoalCards__goalDifficulty___yMfv9`,
	"beeminderLink": `GoalCards__beeminderLink___NaqF1`,
	"arrowIcon": `GoalCards__arrowIcon___gQAO4`
};
module.exports = ___CSS_LOADER_EXPORT___;
